import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import PopUp from '../../../../Shared/Popup/PopUp';
import { buildUrlAndOpenWindow, buildUrlAndOpenSameWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import { reportDWH, updateMesh } from '../../AddonsBlockSlice';
import { getSalePricesAsync, getTechnicianTimesAsync } from '../../AddonsBlockAsyncThunk';
import Config from '../../../../../Config';
import { gtag4 } from '../../../../../utilities/analytics/tracking';
import iconPlusDisabled from './images/icon-plus-disabled.svg';
import iconMinusDisabled from './images/icon-minus-disabled.svg';
import iconPlus from './images/icon-plus.svg';
import infoIcon from './images/info-icon.svg';
import iconMinus from './images/icon-minus.svg';
const MeshPage = (props) => {
    const [isDisplayPopup, setIsDisplayPopup] = useState(false);
    const [isDisplayCountInfoPopup, setIsDisplayCountInfoPopup] = useState(false);
    const [isDisplayMeshPopup, setIsDisplayMeshPopup] = useState(true);
    const [serviceData, setServiceData] = useState({
        isConfirmTerms: { value: false, error: '' },
        email: { value: props.primaryEmail, error: '' }
    });

    useEffect(() => {
        props.reportDWH({ actionType: 'Internet Service Page', status: 'Ongoing', messageText: 'Internet Service Page Displayed' });
        gtag4({ event: `Addon_${props.flowType}_Step3_MeshInfoPage`, step: '3', action: 'MeshInfoPage', funnel_name: `Addon_${props.flowType}` });

        if (props.isAlternativeAddon && props.isDisplayAlternativeMeshPopup) {
            props.reportDWH({ actionType: 'PopUp Redirect to other MESH', status: 'Ongoing', messageText: 'PopUp Redirect to other MESH Displayed' });
            gtag4({ event: `Addon_${props.flowType}_Step2_IrelevantProductsPopUp`, step: '2', action: 'IrelevantProductsPopUp', funnel_name: `Addon_${props.flowType}` });
        }
    }, []);

    return (
        <div className='mesh-page'>

            <div className='mesh-title'> {props.addon.cmsData?.productNameSelfCare} </div>

            {
                props.addon.cmsData?.descriptionProductSelfCare &&
                <div className='description' dangerouslySetInnerHTML={{ __html: props.addon.cmsData?.descriptionProductSelfCare }}></div>
            }

            <div className='mesh-image'>
                <Image src={Config.epiBaseUrl + props.addon.cmsData?.imageAddonSelfCare} alt={props.addon.cmsData?.productNameSelfCare} />
            </div>

            {
                props.addon.cmsData?.textWithIconList.length > 0 &&
                <div className='properties-wrapper'>
                    <ul className='properties'>
                        {
                            props.addon.cmsData?.textWithIconList.map((item, index) => {
                                return (
                                    <li key={index}>
                                        {item.icon && <span className='property-icon' style={{ backgroundImage: `url(${Config.epiBaseUrl + item.icon})` }}></span>}
                                        <span dangerouslySetInnerHTML={{ __html: item.text }}></span>
                                    </li>
                                );
                            })
                        }
                    </ul>
                </div>
            }

            {
                props.addon.cmsData?.textLinkSelfCare &&
                <>
                    <div className='link-wrapper'>
                        <a href='#' onClick={(e) => handleOpenPopup(e)}>{props.addon.cmsData?.textLinkSelfCare}</a>
                    </div>

                    <PopUp showPopUp={isDisplayPopup} onClose={() => setIsDisplayPopup(false)} footerBtn={{ text: 'חזרה', onBtnClick: handleClosePopup }}>
                        <div className='popup-image'><Image src={Config.epiBaseUrl + props.addon.cmsData?.imagePopUpSelfCare} /></div>
                        <div className='popup-title' dangerouslySetInnerHTML={{ __html: props.addon.cmsData?.titlePopUpSelfCare }}></div>
                        <div className='custom-scrollbar'>
                            <div className='popup-text' dangerouslySetInnerHTML={{ __html: props.addon.cmsData?.textPopUpSelfCare }}></div>
                        </div>
                        {
                            props.addon.cmsData?.textLinkPopUpSelfCare &&
                            <div className='popup-link'>
                                <a href='#' onClick={(e) => { e.preventDefault(); buildUrlAndOpenWindow(props.addon.cmsData?.linkRegulationsSelfCare) }}>{props.addon.cmsData?.textLinkPopUpSelfCare}</a>
                            </div>
                        }
                    </PopUp>
                </>
            }

            <div className='gray-seperator'></div>

            <div className='mesh-details-wrapper'>

                {
                    props.addon.cmsData?.textLinkInfo &&
                    <>
                        <div className='details-title'> {props.addon.cmsData?.textLinkInfo} <a href='#' className='info-icon' onClick={(e) => handleOpenCountInfo(e)} style={{backgroundImage:infoIcon.bg()}}></a> </div>
                        <PopUp showPopUp={isDisplayCountInfoPopup} onClose={() => setIsDisplayCountInfoPopup(false)} footerBtn={{ text: 'חזרה', onBtnClick: handleCloseCountInfoPopup }}>
                            <div className='popup-image'><Image src={Config.epiBaseUrl + props.addon.cmsData?.imagePopUpInfo} /></div>
                            <div className='popup-title' dangerouslySetInnerHTML={{ __html: props.addon.cmsData?.titlePopUpInfo }}></div>
                            <div className='custom-scrollbar'>
                                <div className='popup-text' dangerouslySetInnerHTML={{ __html: props.addon.cmsData?.textPopUpInfo }}></div>
                            </div>
                            {
                                props.addon.cmsData?.textLinkPopUpInfo &&
                                <div className='popup-link'>
                                    <a href='#' onClick={(e) => { e.preventDefault(); buildUrlAndOpenWindow(props.addon.cmsData?.linkPopUpInfo) }}>{props.addon.cmsData?.textLinkPopUpInfo}</a>
                                </div>
                            }
                        </PopUp>
                    </>
                }

                <div className='count-wrapper'>
                    {
                        isDisplayAdd(props.meshList) ? (
                            <button className='btn-add' onClick={() => handleAddMesh(props.meshList)} style={{backgroundImage:iconPlus.bg()}}></button>
                        ) : (
                            <div className='btn-add disabled' style={{backgroundImage:iconPlusDisabled.bg()}}></div>
                        )
                    }
                    <div className='count'> {props.meshList?.length} </div>
                    {
                        isDisplayRemove(props.meshList) ? (
                            <button className='btn-remove' onClick={() => handleRemoveMesh(props.meshList)} style={{backgroundImage:iconMinus.bg()}}></button>
                        ) : (
                            <div className='btn-remove disabled' style={{backgroundImage:iconMinusDisabled.bg()}}></div>
                        )
                    }
                </div>

            </div>


            <div className='price-wrapper'>
                {
                    props.addon.cmsData?.marketingText && displayPrice(props.addon.originalPrice) > displayPrice(props.addon.price) &&
                    < div className='price-title'> {props.addon.cmsData?.marketingText} </div>
                }
                <div className='price-details'>
                    {
                        props.meshList.filter((x) => x.action == 'Add').map((item, index) => {
                            return (
                                <div className='price-row' key={index}>
                                    <div className='price-text'> יחידה {index + 1} </div>
                                    <div className='price'>
                                        {
                                            displayPrice(item.price) == 0 ? (
                                                <span className='no-price'> ללא עלות </span>
                                            ) : (
                                                <> {displayPrice(item.price)}<span className='nis'>₪</span>&nbsp;<span>לחודש</span> </>
                                            )
                                        }
                                        {
                                            displayPrice(item.originalPrice) > displayPrice(item.price) &&
                                            <div className='original-price'>
                                                במקום <div className='price'> {displayPrice(item.originalPrice)}<span>₪</span> </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>
                <div className='bottom-details'>
                    {
                        props.meshList.length > 1 &&
                        <div className='total-price-wrapper'>
                            <div className='total-text'> סה"כ לתשלום </div>
                            <div className='total-price'> {getTotalPrice()}<span className='nis'>₪</span> <span className='price-text'>לחודש</span> </div>
                        </div>
                    }

                    {
                        props.supplyMethod &&
                        <div className='technician-text'>
                            עלות ההתקנה ע"י הטכנאי הינה
                            {
                                displayPrice(props.supplyMethod?.price) == 0 ? (
                                    <> ללא עלות </>
                                ) : (
                                    <> {displayPrice(props.supplyMethod?.price)} ₪ </>
                                )
                            }
                        </div>
                    }
                </div>
            </div>


            {
                props.isDisplayTermsCheckbox &&
                <div className='terms-wrapper'>
                    <CheckBox
                        checked={serviceData.isConfirmTerms.value}
                        label={< > אני מאשר/ת את <a href='#' onClick={() => buildUrlAndOpenWindow(props.termsLink)}>תנאי השירות</a> </>}
                        id='isConfirmTerms'
                        error={serviceData.isConfirmTerms.error}
                        onCheck={() => onCheck('isConfirmTerms')}
                        onUncheck={() => onUncheck('isConfirmTerms')} />
                </div>
            }

            <div className='button-wrapper'>
                <BtnSubmit
                    isBusiness={false}
                    text='אישור והזמנה'
                    onclick={handleOnContinue}
                    formid='service-page'
                    isDisplayArrows={false}
                    isDisplayWhatsAppIcon={false}
                />
            </div>

            {
                props.isAlternativeAddon && props.isDisplayAlternativeMeshPopup &&
                <PopUp showPopUp={isDisplayMeshPopup} onClose={() => handleCloseMeshPopup()} footerBtn={{ text: 'הבנתי', onBtnClick: () => handleCloseMeshPopup() }}>
                    <div className='popup-image'><Image src={require('./images/light-icon.svg')} /></div>
                    <div className='popup-title'> רק רגע </div>
                    <div className='custom-scrollbar'>
                        <div className='popup-text' style={{ textAlign: 'center' }}> הציוד שלך מתאים ל-<span className='addon-name'>{props.addon.cmsData?.productNameSelfCare}</span>, <br /> כבר מעבירים אותך לעמוד הנכון  </div>
                    </div>
                </PopUp>
            }

        </div>
    );


    function onCheck(checkboxName) {
        serviceData[checkboxName].value = true;
        serviceData[checkboxName].error = '';
        setServiceData({ ...serviceData });
    }


    function onUncheck(checkboxName) {
        serviceData[checkboxName].value = false;
        serviceData[checkboxName].error = 'נא לאשר את תנאי החבילה';
        setServiceData({ ...serviceData });
    }


    //---------------------------------------------------
    function handleAddMesh(meshList) {
        const count = meshList?.length;

        let data = {
            name: props.addon.name,
            count: count + 1,
            action: 'add'
        };
        props.updateMesh(data);
        props.getSalePricesAsync({ isDisplayLoader: true });
    }

    function handleRemoveMesh(meshList) {
        const count = meshList?.length;
        if (count == 1) { return; };

        let data = {
            name: props.addon.name,
            count: count > 0 ? count - 1 : 0,
            action: 'remove'
        };
        props.updateMesh(data);
        props.getSalePricesAsync({ isDisplayLoader: true });
    }

    function isDisplayAdd(meshList) {
        return (meshList?.length < props.addon.upperLimit);
    }

    function isDisplayRemove(meshList) {
        return (meshList?.length > props.addon.lowerLimit && meshList?.length > 1);
    }
    //---------------------------------------------------


    function getTotalPrice() {
        const total = props.meshList.reduce(function (a, b) {
            return a + parseFloat(b['price']);
        }, 0);
        return parseFloat(total.toFixed(2));
    }

    function displayPrice(price) {
        if (typeof price === 'number') {
            return parseFloat(price.toFixed(2));
        }
        else {
            const res = parseFloat(parseFloat(price).toFixed(2));
            return res == NaN ? 0 : res;
        }
    };


    function handleOpenPopup(e) {
        e.preventDefault();
        setIsDisplayPopup(true);
    }


    function handleClosePopup() {
        setIsDisplayPopup(false);
    }


    function handleOpenCountInfo(e) {
        e.preventDefault();
        setIsDisplayCountInfoPopup(true);
    }


    function handleCloseCountInfoPopup() {
        setIsDisplayCountInfoPopup(false);
    }


    function handleCloseMeshPopup() {
        props.reportDWH({ actionType: 'PopUp Redirect to other MESH', status: 'Ongoing', messageText: 'PopUp Redirect to other MESH Clicked' });
        gtag4({ event: `Addon_${props.flowType}_Step2_IrelevantProductsPopUpContinueButton`, step: '2', action: 'IrelevantProductsPopUpContinueButton', funnel_name: `Addon_${props.flowType}` });

        if (props.addon?.name == 'MESH') {
            buildUrlAndOpenSameWindow(props.meshLink);
            return;
        }

        if (props.addon?.name == 'MESHUL') {
            buildUrlAndOpenSameWindow(props.meshUltraLink);
            return;
        }

        if (props.addon?.name == 'MESHPR') {
          buildUrlAndOpenSameWindow(props.meshStarProLink);
          return;
        }

        //setIsDisplayMeshPopup(false);
    }


    function handleOnContinue() {
        const isValid = validatePage();
        if (!isValid) { return; }
        props.reportDWH({ actionType: 'Internet Service Page', status: 'Ongoing', messageText: 'Internet Service Page Clicked' });
        gtag4({ event: `Addon_${props.flowType}_Step2_MeshInfoContinueButton`, step: '3', action: 'MeshInfoContinueButton', funnel_name: `Addon_${props.flowType}` });
        props.getTechnicianTimesAsync();
    }


    function validatePage() {
        let isValid = true;

        if (props.isDisplayTermsCheckbox) {
            if (!serviceData.isConfirmTerms.value) {
                serviceData.isConfirmTerms.error = 'נא לאשר את תנאי החבילה';
                isValid = false;
            }
        }

        setServiceData({ ...serviceData });
        return isValid;
    }

};

const mapStateToProps = (state) => {
    return {
        flowType: state.addonsBlock.flowType,
        isDisplayTermsCheckbox: state.addonsBlock.isDisplayTermsCheckbox,
        termsLink: state.addonsBlock.termsLink,
        meshLink: state.addonsBlock.meshLink,
        meshUltraLink: state.addonsBlock.meshUltraLink,
        meshStarProLink: state.addonsBlock.meshStarProLink,
        addon: state.addonsBlock.saleCatalog.addons?.find((x) => x.name == state.addonsBlock.addonId),
        meshList: state.addonsBlock.saleCatalog.addons?.filter((x) => x.name == state.addonsBlock.addonId && x.action == 'Add'),
        primaryEmail: state.addonsBlock.subscriber.primaryEmail,
        isAlternativeAddon: state.addonsBlock.isAlternativeAddon,
        isDisplayAlternativeMeshPopup: state.addonsBlock.isDisplayAlternativeMeshPopup,
        supplyMethod: state.addonsBlock.saleCatalog?.supplyMethods?.find((x) => x.name == 'Technician')
    };
};

const mapDispatchToProps = {
    reportDWH,
    updateMesh,
    getSalePricesAsync,
    getTechnicianTimesAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(MeshPage);
